import { ca } from '@cian/analytics';

import { IJsonQuery } from 'shared/json_query';

export function trackAdFoxBannerClick(jsonQuery: IJsonQuery, source?: string) {
  ca('eventSite', {
    action: 'click_sopr',
    category: 'trap',
    label: 'AdFox_banner',
    event: 'oldevent',
    sc: jsonQuery,
    useLastProducts: true,
    page: {
      extra: {
        trap_type: 'AdFox',
        bannerName: 'Adfox ТГБ баннер',
        trapid: 'Adfox ТГБ баннер',
        source,
      },
    },
  });
}

export function trackAdFoxBannerView(jsonQuery: IJsonQuery, source?: string) {
  ca('eventSite', {
    action: 'show_sopr',
    category: 'trap',
    label: 'AdFox_banner',
    event: 'oldevent',
    sc: jsonQuery,
    useLastProducts: true,
    page: {
      extra: {
        trap_type: 'AdFox',
        bannerName: 'Adfox ТГБ баннер',
        trapid: 'Adfox ТГБ баннер',
        source,
      },
    },
  });
}
